import loader from '@assets/loader.gif';
import Title from '@components/Title/Title';
import * as style from './index.css';

const Submitting = () => (
  <section className={style.wrapper} data-testid='test_loader'>
    <section className={style.content}>
      <Title title='Bien reçu' context='loader' />
      <section className={style.contentText}>
        <span className={style.contentTitle}>Veuillez patienter</span>
        <span className={style.comma}>, </span>
        nous traitons votre demande.
      </section>
      <section className={style.imageWrapper}>
        <img className={style.image} src={loader} alt='' />
      </section>
      <section className={style.subText}>
        Nous vous redirigeons dans quelques secondes…
      </section>
    </section>
  </section>
);

export default Submitting;
